import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { SyncOrderTransactions } from '../../../prePaidTickets/domain/dtos/SyncPrePaidTickets';

interface IPartialPaymentStore {
    paidAmount: number;
    setPaidAmount: (value: number) => void;
    amountToPay: number;
    setAmountToPay: (value: number) => void;
    total: number;
    setTotal: (value: number) => void;
    transactions: SyncOrderTransactions[];
    setTransactions: (value: SyncOrderTransactions[]) => void;
    clearPartialPayment: () => void;
}

export const usePartialPaymentStore = create<IPartialPaymentStore>()(
  persist(
    (set) => ({
        paidAmount: 0,
        setPaidAmount: (value: number) => {
            set(state => ({
                paidAmount: state.paidAmount + value
            }))
        },
        amountToPay: 0,
        setAmountToPay: (value: number) => {
            set({ amountToPay: value })
        },
        total: 0,
        setTotal: (value: number) => {
            set({ total: value })
        },
        transactions: [],
        setTransactions: (value: SyncOrderTransactions[]) => {
            set({ transactions: value })
        },
        clearPartialPayment: () => {
            set({
                paidAmount: 0, amountToPay: 0, total: 0, transactions: []
            })
        },
    }),
    {
      name: 'partialPaymentStore'
    }
));



